import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=1c2eb96e&scoped=true"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatingButtons.vue?vue&type=style&index=0&id=1c2eb96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2eb96e",
  null
  
)

export default component.exports